import styled from 'styled-components';

export const HighLightItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-wrap: nowrap;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.palette.primaryBrand};
      border: 2px solid ${({ theme }) => theme.palette.primaryBrandSoft};
    }
  }
`;

export const HighlightItemDot = styled.span`
  margin-right: 3px;
  height: 100%;
  line-height: 125%;
`;

export const HighlightItem = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGray};

  margin-right: 12px;
  display: flex;
  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    min-width: fit-content;
    height: 100%;
    align-items: flex-start;
    margin-right: 15px;
    border-radius: 4px;
  }
`;
